import React, { useState, useEffect, useRef } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Dialog,
  Box,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Switch,
  FormControlLabel
} from "@material-ui/core/"
import { closeCreateOrganizationDialog } from "actions/create-organization-dialog"
import Logo from "../../assets/firstline_social_icon_logo.png"
import { Formik, Form } from "formik"
import ReusableFormControl from "../../components/ReusableFormControl"
import MaskedSubDomain from "../../components/MaskedSubDomain"
import GooglePlacesAutocomplete from "react-google-places-autocomplete"
import { geocodeByPlaceId } from "react-google-places-autocomplete/dist/utils/googleGeocodesHelper"
import MaskedMobileInput from "../../components/MaskedMobileInput"
import { useDebounce } from "use-lodash-debounce"
import {
  checkOrgSubdomain,
  addStripeToOrg,
  chargeOrgForSubscription,
  createOrg,
  checkGroupCode
} from "actions/organization"
import * as Yup from "yup"
import { CardElement } from "@stripe/react-stripe-js"
import { useStripe, useElements } from "@stripe/react-stripe-js"
import { useDispatch, useSelector } from "react-redux"
import { openSnackBar } from "actions/snack-bar"
import API from "store/api"
import LoaderButton from "../../components/LoaderButton"
import MaskedOrganizationCode from "components/MaskedOrganizationCode"

const defaultFormState = {
  organizationName: "",
  organizationSubDomain: "",
  firstName: "",
  lastName: "",
  address: null,
  phone: "",
  email: "",
  plan: "",
  groupCode: ""
}

const CreateOrganizationDialog = ({ fullScreen, classes, open }) => {
  const stripe = useStripe()
  const elements = useElements()
  const formRef = useRef(null)
  const dispatch = useDispatch()
  const [working, setWorking] = useState(false)
  const [validSubdomain, setValidSubdomain] = useState(false)
  const [validGroupCode, setValidGroupCode] = useState(false)
  const [groupCodeId, setGroupCodeId] = useState(0)
  const [checkingSubdomain, setCheckingSubdomain] = useState(false)
  const [checkingGroupCode, setCheckingGroupCode] = useState(false)
  const [plans, setPlans] = useState([])
  const [useGroupCode, setUseGroupCode] = useState(false)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const authentication = useSelector(state => state.authentication)
  const [formState, setFormState] = useState(defaultFormState)

  const handleClose = () => {
    dispatch(closeCreateOrganizationDialog())
    setFormState(defaultFormState)
  }

  const setFormData = e => {
    setFormState(oldState => ({
      ...oldState,
      [e.target.name]: e.target.value
    }))
  }

  const OrganizationSchema = Yup.object().shape({
    organizationName: Yup.string().required("Required"),
    organizationSubDomain: Yup.string().required("Required"),
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    address: Yup.string()
      .required("Required")
      .nullable(),
    email: Yup.string()
      .email()
      .required("Required"),
    phone: Yup.string()
      .required("Required")
      .length(14, "Please enter a mobile phone number")
  })
  const bouncedSubdomain = useDebounce(formState.organizationSubDomain, 200)
  const boundedGroupCode = useDebounce(formState.groupCode, 200)

  useEffect(() => {
    if (bouncedSubdomain) {
      setCheckingSubdomain(true)
      dispatch(checkOrgSubdomain(formState.organizationSubDomain))
        .then(() => setValidSubdomain(true))
        .catch(() => setValidSubdomain(false))
        .finally(() => setCheckingSubdomain(false))
    }
  }, [bouncedSubdomain])

  useEffect(() => {
    if (boundedGroupCode) {
      setCheckingGroupCode(true)
      dispatch(checkGroupCode(formState.groupCode))
        .then(res => {
          setGroupCodeId(res.result[0].id)
          setValidGroupCode(true)
        })
        .catch(() => setValidGroupCode(false))
        .finally(() => setCheckingGroupCode(false))
    }
  }, [boundedGroupCode])

  const extractFromAddress = (components, type, part = "long_name") => {
    for (var i = 0; i < components.length; i++) {
      for (var j = 0; j < components[i].types.length; j++) {
        if (components[i].types[j] === type) return components[i][part]
      }
    }
    return ""
  }

  useEffect(() => {
    if (open) {
      API.get("/stripe/listPlans")
        .then(res => {
          const plans = res.body.plans
          setPlans(plans)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }, [open])

  const getStripeToken = async () => {
    if (!stripe || !elements) {
      console.log("no stripe")
      return
    }
    const cardElement = elements.getElement("card")

    // Use your card Element with other Stripe.js APIs
    const { error, source } = await stripe.createSource(cardElement)

    if (error) {
      throw error
    }
    return source.id
  }

  const formSubmit = () => {
    setWorking(true)
    if (!validSubdomain) {
      dispatch(openSnackBar({ message: "Subdomin is not available" }))
    } else if (useGroupCode && !validGroupCode) {
      dispatch(openSnackBar({ message: "Invalid group code" }))
    } else if (useGroupCode) {
      setWorking(true)
      dispatch(
        createOrg({
          email: formState.email,
          phone: formState.phone,
          address: JSON.stringify(formState.address),
          contact_first_name: formState.firstName,
          contact_last_name: formState.lastName,
          name: formState.organizationName,
          subdomain: formState.organizationSubDomain,
          group_code_id: groupCodeId,
          plan: null
        })
      )
        .then(() => {
          const host = window.location.host.split(".")
          const subdomain = formState.organizationSubDomain
          const userId = authenticatedUser.id
          const token = authentication.token
          if (host.length === 3) {
            window.location.href = `http://${subdomain}.${host[1]}.${host[2]}/admin/settings?token=${token}&user=${userId}`
          } else {
            window.location.href = `http://${subdomain}.${host[0]}.${host[1]}/admin/settings?token=${token}&user=${userId}`
          }
        })
        .catch(err => {
          console.log(err)
          if (err.message) {
            dispatch(openSnackBar({ message: err.message }))
          } else {
            dispatch(openSnackBar({ message: err }))
          }
        })
        .finally(() => {
          setWorking(false)
        })
    } else {
      let stripeToken = ""
      setWorking(true)
      let orgId = null
      getStripeToken()
        .then(token => {
          stripeToken = token
          return dispatch(
            createOrg({
              email: formState.email,
              phone: formState.phone,
              address: JSON.stringify(formState.address),
              contact_first_name: formState.firstName,
              contact_last_name: formState.lastName,
              name: formState.organizationName,
              subdomain: formState.organizationSubDomain,
              plan: formState.plan,
              group_code_id: null
            })
          )
        })
        .then(org => {
          orgId = org.orgId
          return dispatch(addStripeToOrg(orgId, stripeToken))
        })
        .then(() => {
          return dispatch(chargeOrgForSubscription(orgId))
        })
        .then(() => {
          const host = window.location.host.split(".")
          const subdomain = formState.organizationSubDomain
          const userId = authenticatedUser.id
          const token = authentication.token
          if (host.length === 3) {
            window.location.href = `http://${subdomain}.${host[1]}.${host[2]}/admin/settings?token=${token}&user=${userId}`
          } else {
            window.location.href = `http://${subdomain}.${host[0]}.${host[1]}/admin/settings?token=${token}&user=${userId}`
          }
        })
        .catch(err => {
          console.log(err)
          if (err.message) {
            dispatch(openSnackBar({ message: err.message }))
          } else {
            dispatch(openSnackBar({ message: err }))
          }
        })
        .finally(() => {
          setWorking(false)
        })
    }
  }

  return (
    <Dialog
      className={classes.createOrganizationDialog}
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{
        classes: {
          root: classes.dialogPaper
        }
      }}
    >
      <Box display="flex" justifyContent="center">
        <img
          src={Logo}
          alt="FirstLine Social Logo"
          className={classes.logoContainer}
        />
      </Box>

      <Box className={classes.contentContainer}>
        <Formik
          initialValues={formState}
          validationSchema={OrganizationSchema}
          onSubmit={formSubmit}
          innerRef={formRef}
        >
          {formikProps => {
            const handleChange = formikProps.handleChange
            formikProps.handleChange = e => {
              if (e.target.id === "organizationName") {
                formikProps.handleChange({
                  target: {
                    id: "organizationSubDomain",
                    name: "organizationSubDomain",
                    value: e.target.value.replace(/[^\w\d]/g, "").toLowerCase()
                  }
                })
              }
              handleChange(e)
              setFormData(e)
            }
            return (
              <Box className={classes.codeInputContainer}>
                <Form>
                  <ReusableFormControl
                    name={"organizationName"}
                    label="Organization Name"
                    formikProps={formikProps}
                    inputClass={classes.inputReusableFormControl}
                    inputLabelClass={classes.labelTextColor}
                  />

                  <ReusableFormControl
                    name="organizationSubDomain"
                    label="Organization Sub Domain"
                    formikProps={formikProps}
                    inputProps={{
                      inputComponent: MaskedSubDomain
                    }}
                    value={formState.organizationName.toLowerCase()}
                    inputClass={classes.inputReusableFormControl}
                    inputLabelClass={classes.labelTextColor}
                  />

                  <ReusableFormControl
                    name={"firstName"}
                    label="First Name"
                    formikProps={formikProps}
                    inputClass={classes.inputReusableFormControl}
                    inputProps={{ autoComplete: "false" }}
                    inputLabelClass={classes.labelTextColor}
                  />
                  <ReusableFormControl
                    name={"lastName"}
                    label="Last Name"
                    formikProps={formikProps}
                    inputClass={classes.inputReusableFormControl}
                    inputProps={{ autoComplete: "off" }}
                    inputLabelClass={classes.labelTextColor}
                  />

                  <GooglePlacesAutocomplete
                    suggestionsClassNames={{
                      container: classes.locationSuggestionContainer,
                      suggestion: classes.locationSuggestion,
                      suggestionActive: classes.locationSuggestionActive
                    }}
                    placeholder=""
                    loader={<div style={{ display: "none" }} />}
                    debounce={300}
                    onSelect={place => {
                      let placeObj = {
                        address: place.description,
                        placeId: place.place_id,
                        city: null,
                        state: null,
                        zip: null,
                        country: null,
                        street: null
                      }
                      geocodeByPlaceId(place.place_id)
                        .then(results => {
                          const streetNumber = extractFromAddress(
                            results[0].address_components,
                            "street_number"
                          )
                          const route = extractFromAddress(
                            results[0].address_components,
                            "route"
                          )
                          const city = extractFromAddress(
                            results[0].address_components,
                            "locality"
                          )
                          const state = extractFromAddress(
                            results[0].address_components,
                            "administrative_area_level_1",
                            "short_name"
                          )
                          const zip = extractFromAddress(
                            results[0].address_components,
                            "postal_code"
                          )
                          const country = extractFromAddress(
                            results[0].address_components,
                            "country"
                          )

                          const place = {
                            street: `${streetNumber} ${route}`,
                            city,
                            state,
                            zip,
                            country
                          }
                          placeObj = { ...placeObj, ...place }
                        })
                        .catch(err => {
                          console.log(err)
                        })
                        .finally(() => {
                          formikProps.setFieldValue(
                            "address",
                            place.description
                          )
                          setFormData({
                            target: {
                              value: placeObj,
                              name: "address"
                            }
                          })
                        })
                    }}
                    renderInput={props => {
                      return (
                        <ReusableFormControl
                          id="address"
                          name="address"
                          label="Address"
                          formikProps={formikProps}
                          inputLabelClass={classes.labelTextColor}
                          inputProps={{
                            onKeyUp: e =>
                              formikProps.setFieldValue("address", ""),
                            ...props
                          }}
                        />
                      )
                    }}
                  />
                  <ReusableFormControl
                    name={"email"}
                    label="Email"
                    formikProps={formikProps}
                    inputClass={classes.inputReusableFormControl}
                    inputLabelClass={classes.labelTextColor}
                  />
                  <ReusableFormControl
                    name="phone"
                    label="Phone"
                    formikProps={formikProps}
                    inputLabelClass={classes.labelTextColor}
                    inputProps={{
                      inputComponent: MaskedMobileInput
                    }}
                  />

                  <Box display="flex" justifyContent="center">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={useGroupCode}
                          onChange={() => setUseGroupCode(e => !e)}
                          color="primary"
                        />
                      }
                      label="Use Group Code"
                    />
                  </Box>
                  {useGroupCode ? (
                    <ReusableFormControl
                      name="groupCode"
                      label="Group Code"
                      formikProps={formikProps}
                      inputLabelClass={classes.labelTextColor}
                      inputProps={{
                        inputComponent: MaskedOrganizationCode
                      }}
                    />
                  ) : (
                    <Box>
                      <FormControl>
                        <InputLabel id="plan-label">
                          <Typography
                            variant="h5"
                            className={classes.selectPlanText}
                          >
                            Select a Plan
                          </Typography>
                        </InputLabel>
                        <Select
                          labelId="plan-label"
                          id="plan-select"
                          value={formState.plan}
                          onChange={(e, value) => {
                            setFormData({
                              target: {
                                value: value.props.value,
                                name: "plan"
                              }
                            })
                          }}
                        >
                          {plans
                            .slice(0)
                            .reverse()
                            .map((plan, i) => {
                              return (
                                <MenuItem key={i} value={plan.id}>
                                  Plan {plan.nickname}
                                  {": $"}
                                  {" " + plan.amount / 100 + " "}
                                </MenuItem>
                              )
                            })}
                        </Select>
                      </FormControl>
                      <CardElement />
                    </Box>
                  )}
                </Form>
              </Box>
            )
          }}
        </Formik>
      </Box>

      <Box
        className={classes.buttonsContainer}
        display="flex"
        justifyContent="flex-end"
      >
        <Button onClick={handleClose} className={classes.backContainer}>
          Back
        </Button>

        <LoaderButton
          working={working}
          classes={{ button: classes.buttonCreate }}
          onClick={() => formRef.current.submitForm()}
          color="primary"
        >
          Create
        </LoaderButton>
      </Box>
    </Dialog>
  )
}

const mapStateToProps = state => {
  return {
    open: state.createOrganizationDialog.open
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withMobileDialog()
)(CreateOrganizationDialog)



// WEBPACK FOOTER //
// ./src/dialogs/CreateOrganization/index.jsx